import PropTypes from "prop-types";
import { classNamePropType, onChangePropType, childrenPropType } from "../../common";

/**
 * PropTypes for Tabs component
 *
 * @property {Array<{label: string, value: string|number, disabled?: boolean}>} [tabs] - Array of tab objects
 * @property {string|number} [activeTab] - Currently active tab value
 * @property {function} [onChange] - Tab change handler - receives selected tab value
 * @property {string} [className] - Additional CSS classes
 * @property {('horizontal'|'vertical')} [orientation] - Tab layout orientation
 * @property {React.ReactNode} [children] - Tab content panels
 */
export const tabsPropTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    })
  ),
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: onChangePropType,
  className: classNamePropType,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  children: childrenPropType,
};
